<template>
  <div class="page-layout" data-track="Social Ads">
    <!-- Header Section Begins -->
    <div class="level page-info-section">
      <div class="level-left page-layout-head">Social Ad</div>
      <div class="level-right">
        <a
          class="about-feature"
          target="_blank"
          data-track="Show Additional QR Codes view"
          href="https://intercom.help/hellopeter/en/articles/4403194-social-ads"
        >
          <img src="/static/img/dummy-help.png"/>
          <span class="abt_section">About this feature</span>
        </a>
      </div>
    </div>
    <hr class="page-layout-horizontal-row"/>
    <!-- Header Section Ends -->

    <div class="pad-left-13 pad-right-11" :class="{'pad-right-15': isActiveTab('AdsCreator')}">
      <div class="columns custom-tabs-small">
        <div class="column is-12 is-paddingless">
          <div class="tabs is-boxed">
            <ul>
              <li :class="{'is-active': isActiveTab('AdsCreator')}">
                <router-link to="/ads/creator" class="">
                  <span>Image Creator</span>
                </router-link>
              </li>
              <li :class="{'is-active': isActiveTab('AdsLibrary')}">
                <router-link to="/ads/library">
                  <span>Ad Library</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {misc} from '@/mixins'

export default {
  name: 'BaseTemplate',
  mixins: [misc],
  methods: {
    isActiveTab (tab) {
      return this.openActiveTabForURL(this.$router.currentRoute.name, tab)
    }
  }
}
</script>

<style scoped>
.page-layout {
  margin-left: -16px;
  margin-right: -5px;
}

div.page-info-section {
  margin-bottom: 15px;
  margin-top: 7px;
}

.page-layout .page-layout-head {
  font-size: 16px;
  margin-left: 11px;
  color: #58595b;
}

.about-feature {
  margin-right: 10px;
}

.page-layout-horizontal-row {
  margin-bottom: 14px;
}

.page-info-section {
  position: relative;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/social-integration/social-ads/BaseTemplate.vue